// extracted by mini-css-extract-plugin
module.exports = {"modalFooterButton":"RequestInfoModal_modalFooterButton__2Gqu0","requestInfoFormWrapper":"RequestInfoModal_requestInfoFormWrapper__1AEvI"};